module.exports = __webpack_public_path__ + "img/background.b30d2c1d.png";